import { useEffect } from 'react';
import { preloadCriticalComponents } from '../utils/lazyLoadComponents';

const loadPerformanceMonitor = () => import('../utils/performanceMonitor');
const loadAuthCache = () => import('../services/authCache');

export const useAppInitialization = () => {
  // Add immediate debug output
  useEffect(() => {
  }, []);
  
  // Initialize performance monitoring and intelligent preloading system
  useEffect(() => {
    // Defer performance monitoring to reduce initial bundle
    loadPerformanceMonitor().then(({ markPerformance, measurePerformance, performanceMonitor }) => {
      // Mark app initialization start
      markPerformance('app_init_start');
      
      // Initialize performance monitoring with production endpoint if available
      const isDevelopment = import.meta.env.DEV;
      
      if (!isDevelopment && import.meta.env.VITE_PERFORMANCE_ENDPOINT) {
        performanceMonitor.setReportingEndpoint(import.meta.env.VITE_PERFORMANCE_ENDPOINT);
      }
      
      // Mark app initialization end
      setTimeout(() => {
        measurePerformance('app_initialization', 'app_init_start');
      }, 0);
    });
    
    // Initialize auth cache on app startup (deferred)
    loadAuthCache().then(({ initializeAuthCache }) => {
      initializeAuthCache().catch(console.error);
    });
    
    // Initialize image upload service bucket
    import('../services/imageUploadService').then(({ imageUploadService }) => {
      imageUploadService.ensureBucketExists().catch(console.error);
    });
    
    // Initialize preloading system
    preloadCriticalComponents();
  }, []);
};